/** Shared Tailwind classes for activity builder tabs (admin + supplier). */

export const abSectionCard =
  "rounded-xl border border-gray-200/60 bg-white shadow-sm";

export const abInnerSection =
  "rounded-xl border border-gray-200/80 bg-white p-4 sm:p-5 shadow-sm";

export const abItemCardShell =
  "rounded-xl border border-gray-200/80 bg-white shadow-sm";

export const abItemCard =
  "rounded-xl border border-gray-200/80 bg-white p-4 shadow-sm";

export const abIndexBadge =
  "flex h-8 w-8 shrink-0 items-center justify-center rounded-lg border border-gray-200 bg-white text-xs font-semibold text-gray-700 shadow-sm";

export const abStayIndexBadge =
  "flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-gray-900 text-sm font-semibold text-white shadow-sm";

export const abDeleteBtn =
  "flex h-8 w-8 shrink-0 items-center justify-center rounded-lg border border-red-100 bg-red-50 text-red-500 transition hover:border-red-200 hover:bg-red-100";

export const abAddBtn =
  "inline-flex items-center justify-center gap-2 rounded-lg border border-gray-200 bg-white px-4 py-2.5 text-sm font-medium text-gray-700 transition hover:border-gray-300 hover:bg-gray-50";

export const abAddBtnFull =
  "flex w-full items-center justify-center gap-2 rounded-lg border border-gray-200 bg-white px-4 py-2.5 text-sm font-medium text-gray-700 transition hover:border-gray-300 hover:bg-gray-50";

export const abSectionTitle = "text-sm font-bold text-gray-900";

export const abSectionSubtitle = "mt-0.5 text-xs text-gray-500";

export const abFieldLabel =
  "mb-1.5 block text-xs font-medium text-gray-600";

export const abFieldInput =
  "w-full rounded-lg border border-gray-200 px-3 py-2 text-sm font-medium text-gray-800 placeholder:text-sm placeholder:font-normal placeholder:text-gray-400 focus:border-primary focus:outline-none focus:ring-1 focus:ring-primary/20";

export const abListFieldInput =
  "flex-1 rounded-lg border border-gray-200 px-3 py-2 text-sm font-medium text-gray-800 placeholder:font-normal placeholder:text-gray-400 focus:border-primary focus:outline-none focus:ring-1 focus:ring-primary/20";

export const abEmptyState =
  "rounded-xl border border-gray-100 bg-slate-50/40 px-4 py-6 text-sm text-gray-600";

export const abEditorWrap =
  "overflow-hidden rounded-xl border border-gray-200/60 bg-white shadow-sm";
